function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

const selectVariantByClickingImage = {
  // Create variant images from productJson object
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (
        typeof variant.featured_image !== 'undefined' &&
        variant.featured_image !== null
      ) {
        const variantImage = variant.featured_image.src
          .split('?')[0]
          .replace(/http(s)?:/, '');
        variantImageObject[variantImage] =
          variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (
            typeof variantImageObject[variantImage][optionKey] === 'undefined'
          ) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
    return variantImageObject;
  },
  _updateVariant: function (event, id, product, variantImages) {
    const arrImage = event.target.src
      .split('?')[0]
      .replace(/http(s)?:/, '')
      .split('.');
    const strExtention = arrImage.pop();
    const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
    const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
    if (typeof variantImages[strNewImage] !== 'undefined') {
      product.variants.forEach((option, index) => {
        const optionValue = variantImages[strNewImage][`option-${index}`];
        if (optionValue !== null && optionValue !== undefined) {
          const selects = document.querySelectorAll('#'+ id + ' [class*=single-option-selector]');
          const options = selects[index].options;
          for (let option, n = 0; (option = options[n]); n += 1) {
            if (option.value === optionValue) {
              selects[index].selectedIndex = n;
              selects[index].dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      });
    }
  },
  _selectVariant: function() {
    const productJson = document.querySelectorAll('[id^=ProductJson-');
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace("ProductJson-", "shopify-section-");
        const thumbnails = document.querySelectorAll('#'+ sectionId + ' img[src*="/files/"]');
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);
          // need to check variants > 1
          if (productObject.variants.length > 1) {
            thumbnails.forEach((thumbnail) => {
              thumbnail.addEventListener('click', (e) =>
                this._updateVariant(e, sectionId, productObject, variantImages),
              );
            });
          }
        }
      });
    }
  },
};
if (document.readyState !== 'loading') {
  selectVariantByClickingImage._selectVariant();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    selectVariantByClickingImage._selectVariant(),
  );
}

(function(funcName, baseObj) {
    // The public function name defaults to window.docReady
    // but you can pass in your own object and own function name and those will be used
    // if you want to put them in a different namespace
    funcName = funcName || "docReady";
    baseObj = baseObj || window;
    var readyList = [];
    var readyFired = false;
    var readyEventHandlersInstalled = false;

    // call this when the document is ready
    // this function protects itself against being called more than once
    function ready() {
        if (!readyFired) {
            // this must be set to true before we start calling callbacks
            readyFired = true;
            for (var i = 0; i < readyList.length; i++) {
                // if a callback here happens to add new ready handlers,
                // the docReady() function will see that it already fired
                // and will schedule the callback to run right after
                // this event loop finishes so all handlers will still execute
                // in order and no new ones will be added to the readyList
                // while we are processing the list
                readyList[i].fn.call(window, readyList[i].ctx);
            }
            // allow any closures held by these functions to free
            readyList = [];
        }
    }

    function readyStateChange() {
        if ( document.readyState === "complete" ) {
            ready();
        }
    }

    // This is the one public interface
    // docReady(fn, context);
    // the context argument is optional - if present, it will be passed
    // as an argument to the callback
    baseObj[funcName] = function(callback, context) {
        if (typeof callback !== "function") {
            throw new TypeError("callback for docReady(fn) must be a function");
        }
        // if ready has already fired, then just schedule the callback
        // to fire asynchronously, but right away
        if (readyFired) {
            setTimeout(function() {callback(context);}, 1);
            return;
        } else {
            // add the function and context to the list
            readyList.push({fn: callback, ctx: context});
        }
        // if document already ready to go, schedule the ready function to run
        if (document.readyState === "complete") {
            setTimeout(ready, 1);
        } else if (!readyEventHandlersInstalled) {
            // otherwise if we don't have event handlers installed, install them
            if (document.addEventListener) {
                // first choice is DOMContentLoaded event
                document.addEventListener("DOMContentLoaded", ready, false);
                // backup is window load event
                window.addEventListener("load", ready, false);
            } else {
                // must be IE
                document.attachEvent("onreadystatechange", readyStateChange);
                window.attachEvent("onload", ready);
            }
            readyEventHandlersInstalled = true;
        }
    }
})("docReady", window);

docReady(function() {
  const headerHeight = document.querySelector('sticky-header').offsetHeight;
  
  Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
      get: function(){
          return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
      }
  });
  
  function addListenerMulti(el, s, fn) {
      s.split(' ').forEach(e => el.addEventListener(e, fn, false));
  }

  function updateMaxMediaWrapperHeight() {
    if (window.innerWidth > 768) return;
  
    // Get the first .product__media-wrapper element
    const mediaWrapper = document.querySelector('.product .grid__item.product__media-wrapper');
    
    if (mediaWrapper) {
      // Get the immediate child of the wrapper
      const child = mediaWrapper.firstElementChild;
  
      if (child) {
        // Set the CSS variable --media-wrapper-max-height on the root or parent element
        document.documentElement.style.setProperty('--media-wrapper-max-height', child.offsetHeight + 'px');
      }
    }
  }

  waitForElm('media-gallery').then((elm) => {
    window.addEventListener('resize', updateMaxMediaWrapperHeight);
  
    updateMaxMediaWrapperHeight();
  });
  
  let videoContainers = document.querySelectorAll('.video-and-image__video');
  let videos = document.querySelectorAll('video');

  /*
  videos.forEach((video) => {
    video.addEventListener("click", () => {
      if (!video.playing) {
        video.pause();
      } else {
        video.play();
      }
    })
  });
  */
  
  videoContainers.forEach((videoContainer) => {
      videoContainer.addEventListener("click", () => {
        let video = videoContainer.querySelector('video');
        
        if (video.playing) {
          video.pause();
        } else {
          video.play();
        }
      });
    
      addListenerMulti(videoContainer.querySelector('video'), 'play', function(e) {
          videoContainer.classList.add('video--playing');
      });
      
      addListenerMulti(videoContainer.querySelector('video'), 'pause', function(e) {
          videoContainer.classList.remove('video--playing');
      });
  });

  let accordions = document.querySelectorAll('.accordion');
  let details = document.querySelectorAll('.accordion details');
  let summaries = document.querySelectorAll('.accordion summary');
  
  //document.addEventListener('toggle', toggleHandler, true);
  // TODO for future: take height of closed accordion and add it to the scroll offset, so that when this is maybe enabled again in the future, it won't scroll further than the next to be opened accordion

  let accordionToggles = document.querySelectorAll('.accordion .icon-toggle__open');

  if(accordionToggles !== null) {
    for (let toggle of accordionToggles) {
      toggle.addEventListener('click', (e) => {
        let scrollToMe = e.currentTarget.parentElement.closest('.accordion');
        let accordionContentHeight = scrollToMe.querySelector('.accordion__content').offsetHeight;
        let offset = 100;
        
        if(accordionContentHeight != 0) {
          offset = (accordionContentHeight / 2);
        }
        
        const topOfElement = window.pageYOffset + scrollToMe.getBoundingClientRect().top - headerHeight - offset;

        window.scroll({ top: topOfElement, behavior: "smooth" });
      });
    }
  }

  let elementTargetOnLoad = document.getElementById(location.hash.slice(1));
  if(elementTargetOnLoad !== null) {
    const isAccordion =  elementTargetOnLoad.classList.contains('product__accordion');

    if(isAccordion) {
      //console.log(elementTargetOnLoad.querySelector("details"));
      elementTargetOnLoad.querySelector("details").setAttribute('open', true);
      elementTargetOnLoad.querySelector("summary").setAttribute('aria-expanded', true);
    }
  }

  /**
  * Handle toggle events
  * @param  {Event} event The Event object
  */
  function toggleHandler (event) {
    // Ignore these accordions (they always stay open)
    let productNoticeTab = event.target.closest('#Details-product_notice');
    let isProductNoticeTab = productNoticeTab !== null;

    /* TODO: gerade noch buggy
    if (isProductNoticeTab) {
      productNoticeTab.open = "true";

      productNoticeTab.querySelector('#Summary-product_notice').setAttribute('aria-expanded', true);
    }
    */
    
    // Only run if accordion is open
    if (!event.target.hasAttribute('open')) return;
  
    // Only run on accordions inside our selector
    let parent = event.target.closest('.accordion').parentElement;
    if (!parent) return;
  
    // Get all open accordions inside parent
    let opened = parent.querySelectorAll('details[open]');
  
    // Close open ones that aren't current accordion
      for (let accordion of opened) {
          if (accordion.closest('.st-tabs__duo') != null) continue;
          if (accordion === event.target) continue;
          accordion.removeAttribute('open');
      }
  
  }

  let productOptionLabels = document.querySelectorAll('fieldset.js.product-form__input label');
  let productDefaultThumbnail = document.querySelector('.product_featured-media-default');

  if(productDefaultThumbnail != null) {
    waitForElm('.product_featured-media-default').then((elm) => {
      for(let optionLabel of productOptionLabels) {
        if(optionLabel !== null) {
  
          /* Remove thumbnail if any option labels sibling input is checked */
          if(optionLabel.previousSibling.previousSibling.checked === true) {
            elm.remove();
            if(document.querySelector('.product__media-item.first').classList.contains('st-hide_initially')) {
              document.querySelector('.product__media-item.first').classList.remove('st-hide_initially');
            }
            
          } else {
            elm.style.display = "block";
          }
          
          optionLabel.addEventListener('click', (e) => {
            if(elm !== null)
              elm.remove();
  
            if(e.currentTarget.getAttribute('for').endsWith('-0')) {
              if(document.querySelector('.product__media-item.first').classList.contains('st-hide_initially')) {
                document.querySelector('.product__media-item.first').classList.remove('st-hide_initially');
              }
            }

            if(document.querySelector('.product__media-item.second').classList.contains('st-hide_initially')) {
              document.querySelector('.product__media-item.second').classList.remove('st-hide_initially');
            }
          });
        }
      }
    });
  } else {
    if(document.querySelector('.product__media-item.first') !== null) {
      if(document.querySelector('.product__media-item.first').classList.contains('st-hide_initially')) {
        document.querySelector('.product__media-item.first').classList.remove('st-hide_initially');
      }
    }
    if(document.querySelector('.product__media-item.second') !== null) {
      if(document.querySelector('.product__media-item.second').classList.contains('st-hide_initially')) {
        document.querySelector('.product__media-item.second').classList.remove('st-hide_initially');
      }
    }
  }
  
});

const link = document.querySelector('a[href*="/#complianz"]');
if (link) {
  const text = link.textContent;
  link.onclick = function(e) {
    e.preventDefault();
    Pandectes.fn.openPreferences();
  };
  link.href = '#';
  link.className = 'link link--text list-menu__item list-menu__item--link';
  link.textContent = text;
}

document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('slider-component');

  if (slider) {
    requestAnimationFrame(() => {
      slider.classList.add('is-visible');
    });
  }
});